import { useState, useContext } from "react";
import Context from "../../storage/context";

const STORAGE_KEY = "like";

function getLikes() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
        return [];
    }
}

function saveLikes(likes) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(likes));
}

export default function HeartButton({ id, size = 22, color = "#E24B4A" }) {
    const [filled, setFilled] = useState(() => getLikes().includes(id));
    const [beat, setBeat] = useState(false);
    let ctx = useContext(Context);

    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const likes = getLikes();
        const newLikes = filled
            ? likes.filter(i => i !== id)
            : [...likes, id];
        ctx.setArrFavCars(newLikes);
        saveLikes(newLikes);
        setFilled(f => !f);
        setBeat(true);
        setTimeout(() => setBeat(false), 300);
    };

    return (
        <button
            className="like-car"
            onClick={handleClick}
            aria-label={filled ? "הסר ממועדפים" : "הוסף למועדפים"}
            style={{
                background: "rgba(255,255,255,0.85)",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
                width: 34,
                height: 34,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
                lineHeight: 0,
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 32 32"
                style={{
                    transform: beat ? "scale(1.35)" : "scale(1)",
                    transition: beat
                        ? "transform 0.15s cubic-bezier(0.36, 0.07, 0.19, 0.97)"
                        : "transform 0.15s ease-out",
                }}
            >
                <path
                    d="M16 25 C4 17 4 8 10 5.5 C12.5 4.5 14.5 5.5 16 8 C17.5 5.5 19.5 4.5 22 5.5 C28 8 28 17 16 25 Z"
                    fill={filled ? color : "none"}
                    stroke={color}
                    strokeWidth="2.2"
                    strokeLinejoin="round"
                    style={{ transition: "fill 0.15s ease" }}
                />
            </svg>
        </button>
    );
}